module.exports = __webpack_public_path__ + "img/format-clear.8ccc501c.svg";